import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { TranslatedLink } from '../components/TranslatedLink'
import Logo from '../components/logo'
import LinkBtn from '../components/linkBtn/LinkBtn'
import MultiTargetTranslatedLink from '../components/MultiTargetTranslatedLink'
import { useStaticQuery, graphql } from 'gatsby'
import {
  getTranslatedSlug,
  getTranslateFunction,
  isBrowser,
  matchPath,
  translatedNavigate,
} from '../utilities'
import useScrollPosition from '@react-hook/window-scroll'
import Img from 'gatsby-image'
//import { LangContext } from './index'
import UnderlineLink from '../components/underlineLink/UnderlineLink'
import MailLink from '../components/mailLink/MailLink'
import MobileMenuAboutUs from '../components/MobileMenuAboutUs'
import MobileMenuBlog from '../components/MobileMenuBlog'
import MobileMenuCaseStudies from '../components/MobileMenuCaseStudies'
import MobileMenuCaseStudyPageShowcase from '../components/MobileMenuCaseStudyPageShowcase'
import MobileMenuServices from '../components/MobileMenuServices'
import SideMenu from '../components/sideMenu/side-menu'
import SideMenuServices from '../components/sideMenu/side-menu-services'
import CaseStudiesSideMenuGhost from '../components/case-studies/caseStudiesSideMenuGhost'
import { globalHistory } from '@reach/router'
import TelephoneNumber from '../components/telephoneNumber/TelephoneNumber'
import Tooltip from 'react-tooltip-lite'
import Svg from 'react-inlinesvg'
//import HoverBtn from '../components/HoverBtn'
import dizajn from '../images/svg/dizajn_svg.svg'
import marketing from '../images/svg/marketing_svg.svg'
import programovanie from '../images/svg/programovanie_svg.svg'
import vykon from '../images/svg/vykon_svg.svg'
import { isEmpty } from 'lodash'

// Nav icon imports - small service icons
import icoWebDizajn from '../images/svg/nav/web-dizajn.svg'
import icoUxUiDizajn from '../images/svg/nav/ux-ui-dizajn.svg'
import icoTvorbaLoga from '../images/svg/nav/tvorba-loga.svg'
import icoBranding from '../images/svg/nav/branding.svg'
import icoGrafickyDizajn from '../images/svg/nav/graficky-dizajn.svg'
import icoTvorbaEshopu from '../images/svg/nav/Tvorba e-shopu.svg'
import icoTvorbaWebstranok from '../images/svg/nav/Tvorba webstránok.svg'
import icoTvorbaWordpress from '../images/svg/nav/Tvorba Wordpress webu.svg'
import icoVyvojWebovych from '../images/svg/nav/Vývoj webových aplikácií.svg'
import icoVyvojMobilnych from '../images/svg/nav/Vývoj mobilných aplikácií.svg'
import icoPPC from '../images/svg/nav/PPC.svg'
import icoOptimalizacie from '../images/svg/nav/optimalizácie.svg'
import icoSpravaSocialnych from '../images/svg/nav/Správa sociálnych sietí.svg'
import icoEmailMarketing from '../images/svg/nav/Email marketing.svg'
import icoCopywriting from '../images/svg/nav/Copywriting.svg'
import icoWebAnalytika from '../images/svg/nav/Webová analytika.svg'
import icoUxAudit from '../images/svg/nav/UX.svg'
import icoAiIntegracia from '../images/svg/nav/AI integrácia.svg'
import icoCX from '../images/svg/nav/CX.svg'
import icoUdrzbaWebu from '../images/svg/nav/Údržba webu.svg'
import ctaDocIcon from '../images/svg/nav/note.svg'
import arowRight from '../images/svg/arrow_right.svg'
import eshopNavImg from '../images/svg/nav/eshop-nav.svg'
import webNavImg from '../images/svg/nav/web-nav.svg'
import adsNavImg from '../images/svg/nav/ads-header.svg'

const Navigation = ({ lang, location, isCaseStudy }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isAnyDropdownOpen, setIsAnyDropdownOpen] = useState(false)
  const openDropdownIdsRef = useRef(new Set())

  const handleDropdownOpenChange = useCallback((dropdownId, isOpen) => {
    const nextOpenDropdownIds = new Set(openDropdownIdsRef.current)

    if (isOpen) {
      nextOpenDropdownIds.add(dropdownId)
    } else {
      nextOpenDropdownIds.delete(dropdownId)
    }

    openDropdownIdsRef.current = nextOpenDropdownIds
    setIsAnyDropdownOpen(nextOpenDropdownIds.size > 0)
  }, [])
  const scrollY = useScrollPosition(60 /*fps*/)
  const isScrolledTop = scrollY === 0
  const navRef = useRef(null)
  const indicatorTargetRef = useRef(null)
  const defaultIndicatorRef = useRef(null)
  const servicesDropdownRef = useRef(null)
  const aboutUsDropdownRef = useRef(null)
  const INDICATOR_DEFAULT_COLOR = '#014EFF'
  const INDICATOR_ACCENT_COLOR = '#EB1260'
  const INDICATOR_SKEW_DEG = -18
  const INDICATOR_SKEW_RAD = Math.abs((INDICATOR_SKEW_DEG * Math.PI) / 180)
  const INDICATOR_SIDE_PADDING = 12
  const indicatorInitialized = useRef(false)
  const indicatorTransitionFrameRef = useRef(null)
  const indicatorTransitionEnableFrameRef = useRef(null)
  const [navIndicator, setNavIndicator] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    visible: false,
    noTransition: true,
    color: INDICATOR_DEFAULT_COLOR,
  })

  const getNavZoom = useCallback(() => {
    if (!isBrowser() || !navRef.current) {
      return 1
    }

    const zoomValue = window.getComputedStyle(navRef.current).zoom
    const parsedZoom = Number.parseFloat(zoomValue)

    return Number.isFinite(parsedZoom) && parsedZoom > 0 ? parsedZoom : 1
  }, [])

  const getIndicatorLayoutForTarget = useCallback(
    (target) => {
      if (!target || !isBrowser() || !navRef.current) {
        return null
      }

      const triggerNode = target.querySelector('.nav-hover-trigger') || target
      const measurementNode =
        triggerNode.querySelector('.LinkBtn .link-text') ||
        triggerNode.querySelector('.link-text') ||
        triggerNode.querySelector('a[href]') ||
        triggerNode
      const navRect = navRef.current.getBoundingClientRect()
      const targetRect = measurementNode.getBoundingClientRect()
      const navZoom = getNavZoom()
      const localLeft = (targetRect.left - navRect.left) / navZoom
      const localWidth = targetRect.width / navZoom
      const UNDERLINE_HEIGHT = 2
      const isAccent =
        triggerNode.classList.contains('red') ||
        target.classList.contains('red')
      const headerEl = navRef.current.closest('header')
      const headerBottom = headerEl
        ? headerEl.getBoundingClientRect().bottom
        : navRect.bottom
      const topFromNav =
        (headerBottom - navRect.top) / navZoom - UNDERLINE_HEIGHT

      return {
        left: localLeft,
        top: topFromNav,
        width: localWidth,
        height: UNDERLINE_HEIGHT,
        visible: true,
        color: isAccent ? INDICATOR_ACCENT_COLOR : INDICATOR_DEFAULT_COLOR,
      }
    },
    [getNavZoom]
  )

  const enableIndicatorTransitionAfterPaint = useCallback(() => {
    if (!isBrowser()) {
      return
    }

    if (indicatorTransitionFrameRef.current) {
      window.cancelAnimationFrame(indicatorTransitionFrameRef.current)
    }

    if (indicatorTransitionEnableFrameRef.current) {
      window.cancelAnimationFrame(indicatorTransitionEnableFrameRef.current)
    }

    indicatorTransitionFrameRef.current = window.requestAnimationFrame(() => {
      indicatorTransitionFrameRef.current = null
      indicatorTransitionEnableFrameRef.current = window.requestAnimationFrame(
        () => {
          indicatorTransitionEnableFrameRef.current = null
          setNavIndicator((prev) =>
            prev.noTransition ? { ...prev, noTransition: false } : prev
          )
        }
      )
    })
  }, [])

  const updateIndicatorForTarget = useCallback(
    (target, rememberAsDefault = false) => {
      const indicatorLayout = getIndicatorLayoutForTarget(target)
      if (!indicatorLayout) {
        return
      }

      const previousTarget = indicatorTargetRef.current
      if (previousTarget && previousTarget !== target) {
        previousTarget.classList.remove('nav-hover-active')
      }

      target.classList.add('nav-hover-active')
      indicatorTargetRef.current = target

      if (rememberAsDefault) {
        defaultIndicatorRef.current = target
      }

      if (!indicatorInitialized.current) {
        indicatorInitialized.current = true
        setNavIndicator({ ...indicatorLayout, noTransition: true })
        enableIndicatorTransitionAfterPaint()
      } else {
        setNavIndicator((prev) => ({
          ...indicatorLayout,
          noTransition: prev.noTransition,
        }))
      }
    },
    [enableIndicatorTransitionAfterPaint, getIndicatorLayoutForTarget]
  )

  const restoreDefaultIndicator = useCallback(() => {
    if (isMobileMenuOpen) {
      return
    }

    if (defaultIndicatorRef.current) {
      updateIndicatorForTarget(defaultIndicatorRef.current, true)
    } else {
      if (indicatorTargetRef.current) {
        indicatorTargetRef.current.classList.remove('nav-hover-active')
        indicatorTargetRef.current = null
      }
      setNavIndicator((prev) =>
        prev.visible ? { ...prev, visible: false } : prev
      )
    }
  }, [isMobileMenuOpen, updateIndicatorForTarget])

  const handleNavItemEnter = useCallback(
    (target) => {
      if (!target || isMobileMenuOpen) {
        return
      }
      updateIndicatorForTarget(target)
    },
    [isMobileMenuOpen, updateIndicatorForTarget]
  )

  useEffect(() => {
    if (!isBrowser()) {
      return
    }

    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMobileMenuOpen(false)
      }

      if (!indicatorTargetRef.current || !navRef.current) {
        return
      }

      const indicatorLayout = getIndicatorLayoutForTarget(
        indicatorTargetRef.current
      )
      if (!indicatorLayout) {
        return
      }

      setNavIndicator((prev) => ({
        ...indicatorLayout,
        visible: prev.visible,
        noTransition: prev.noTransition,
      }))
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [getIndicatorLayoutForTarget])

  useEffect(() => {
    return () => {
      if (!isBrowser()) {
        return
      }

      if (indicatorTransitionFrameRef.current) {
        window.cancelAnimationFrame(indicatorTransitionFrameRef.current)
      }

      if (indicatorTransitionEnableFrameRef.current) {
        window.cancelAnimationFrame(indicatorTransitionEnableFrameRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (isMobileMenuOpen) {
      if (indicatorTargetRef.current) {
        indicatorTargetRef.current.classList.remove('nav-hover-active')
        indicatorTargetRef.current = null
      }
      defaultIndicatorRef.current = null
      setNavIndicator((prev) =>
        prev.visible ? { ...prev, visible: false } : prev
      )
    }
  }, [isMobileMenuOpen])

  const { usFlag } = useStaticQuery(graphql`
    query NavigationUsFlagImage {
      usFlag: file(relativePath: { eq: "us.png" }) {
        childImageSharp {
          fixed(width: 25, quality: 90) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  const t = getTranslateFunction(lang)
  const currentPath = location.pathname

  const path = currentPath.split('#')[0].replace(/\/$/, '')

  useEffect(() => {
    if (!navRef.current || isMobileMenuOpen) {
      return
    }

    const navItems = Array.from(
      navRef.current.querySelectorAll('li[data-nav-item="true"]')
    )
    const activeItem = navItems.find((item) => item.querySelector('.is-active'))

    if (activeItem) {
      updateIndicatorForTarget(activeItem, true)
      if (isBrowser()) {
        window.requestAnimationFrame(() => {
          updateIndicatorForTarget(activeItem, true)
        })
      }
    } else {
      defaultIndicatorRef.current = null
      restoreDefaultIndicator()
    }
  }, [
    path,
    isMobileMenuOpen,
    updateIndicatorForTarget,
    restoreDefaultIndicator,
  ])

  const isAboutUsMenuVisible = [
    '/en/about-us',
    '/o-nas',
    '/en/about-us/clients',
    '/o-nas/klienti',
    '/en/about-us/ux-principes',
    '/o-nas/ux-principy',
    '/en/about-us/how-we-work',
    '/o-nas/ako-pracujeme',
  ].includes(path)

  const isServicesMenuVisible = [
    '/en/services',
    '/sluzby',
    '/en/services/programming',
    '/sluzby/programovanie',
    '/en/services/design',
    '/sluzby/dizajn',
    '/en/services/marketing',
    '/sluzby/marketing',
    '/en/services/vykon-rast',
    '/sluzby/vykon-rast',
    '/en/services/service',
    '/sluzby/servis',
  ].includes(path)

  const isOurWorkMenuVisible = [
    '/en/our-works',
    'nase-prace/vybrane',
    '/en/our-works/featured',
    '/nase-prace/vybrane',
    '/en/our-works/websites',
    '/nase-prace/webstranky',
    '/en/our-works/applications',
    '/nase-prace/aplikacie',
    '/en/our-works/graphics',
    '/nase-prace/grafika',
  ].includes(path)

  const links = [
    {
      title: 'Programovanie',
      link: '/sluzby/programovanie',
      svg: programovanie,
      links: [
        {
          title: 'Tvorba e-shopu',
          link: '/eshop-na-mieru',
          icon: icoTvorbaEshopu,
          desc: 'Vyladený pre vysoké predaje',
        },
        {
          title: 'Tvorba webstránok',
          link: '/tvorba-webov',
          icon: icoTvorbaWebstranok,
          desc: 'Moderný web pre váš biznis',
        },
        {
          title: 'Tvorba Wordpress webu',
          link: '/wodpress-a-woocommerce',
          icon: icoTvorbaWordpress,
          desc: 'Flexibilný web s ľahkou správou',
        },
        {
          title: 'Vývoj webových aplikácií',
          link: '/tvorba-web-aplikacii',
          icon: icoVyvojWebovych,
          desc: 'Komplexné riešenia na mieru',
        },
        {
          title: 'Vývoj mobilných aplikácií',
          link: '/tvorba-mobilnych-aplikacii',
          icon: icoVyvojMobilnych,
          desc: 'Špičkové iOS a Android appky',
        },
      ],
    },
    {
      title: 'Dizajn',
      link: '/sluzby/dizajn',
      svg: dizajn,
      links: [
        {
          title: 'Web dizajn',
          link: '/webdizajn',
          icon: icoWebDizajn,
          desc: 'Na mieru do posledného detailu',
        },
        {
          title: 'UX & UI dizajn',
          link: '/ux-ui-dizajn',
          icon: icoUxUiDizajn,
          desc: 'Intuitívna užívateľská skúsenosť',
        },
        {
          title: 'Tvorba loga',
          link: '/tvorba-loga',
          icon: icoTvorbaLoga,
          desc: 'Zapamätateľné na prvý pohľad',
        },
        {
          title: 'Branding',
          link: '/branding',
          icon: icoBranding,
          desc: 'Vybudujte silnú značku na trhu',
        },
        {
          title: 'Grafický dizajn',
          link: '/graficky-dizajn',
          icon: icoGrafickyDizajn,
          desc: 'Kreatívne a funkčné vizuály',
        },
      ],
    },
    {
      title: 'Marketing',
      link: '/sluzby/marketing',
      svg: marketing,
      links: [
        {
          title: 'Online reklama / PPC',
          link: '/online-reklama-ppc',
          icon: icoPPC,
          desc: 'Rýchly prísun nových dopytov',
        },
        {
          title: 'SEO / optimalizácie',
          link: '/seo-optimalizacie',
          icon: icoOptimalizacie,
          desc: 'Popredné miesta na Googli',
        },
        {
          title: 'Správa sociálnych sietí',
          link: '/sprava-socialnych-sieti',
          icon: icoSpravaSocialnych,
          desc: 'Budujte silnú komunitu online',
        },
        {
          title: 'Email marketing',
          link: '/e-mail-marketing',
          icon: icoEmailMarketing,
          desc: 'Cielené kampane predávajú',
        },
        {
          title: 'Copywriting',
          link: '/copywriting',
          icon: icoCopywriting,
          desc: 'Presvedčivé texty s nápadom',
        },
      ],
    },
    {
      title: 'Výkon / Rast',
      link: '/sluzby/vykon-rast',
      svg: vykon,
      links: [
        {
          title: 'Webová analytika',
          link: '/webova-analytika',
          icon: icoWebAnalytika,
          desc: 'Správne kroky vďaka dátam',
        },
        {
          title: 'Audit webu / UX',
          link: '/audit-webu-ux',
          icon: icoUxAudit,
          desc: 'Odhalenie slabých miest webu',
        },
        {
          title: 'AI integrácia',
          link: '/ai-integracia',
          icon: icoAiIntegracia,
          desc: 'Zefektívnenie vašej práce',
        },
        {
          title: 'Biznis stratégia / CX',
          link: '/biznis-strategia-cx',
          icon: icoCX,
          desc: 'Jasný plán pre stabilný rast',
        },
        {
          title: 'Servis / Údržba webu',
          link: '/sluzby/servis',
          icon: icoUdrzbaWebu,
          desc: 'Bezpečnosť a rýchla podpora',
        },
      ],
    },
  ]

  const navBoxes = [
    {
      title: 'Tvorba E-shopu',
      desc: 'Predávajte viac vďaka moderným funkciám',
      link: '/eshop-na-mieru',
      img: eshopNavImg,
    },
    {
      title: 'Firemné stránky',
      desc: 'Premeňte návštevníkov na zákazníkov',
      link: '/tvorba-webov',
      img: webNavImg,
    },
    {
      title: 'Google ads',
      desc: 'Získajte viac dopytov pre produkty a služby',
      link: '/online-reklama-ppc',
      img: adsNavImg,
    },
  ]

  const aboutUsLinks = {
    title: null,
    link: null,
    class: 'about-us-links',
    links: [
      { title: t('OurServices.Menu'), link: '/o-nas' },
      { title: t('OurWork.Menu'), link: '/o-nas/klienti' },
      { title: t('HowWeWork.Menu'), link: '/o-nas/ako-pracujeme' },
      { title: t('UxPrincipes.Menu'), link: '/o-nas/ux-principy' },
    ],
  }

  const onNavMenuOpen = (value) => {
    if (value) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    if (value) {
      openDropdownIdsRef.current = new Set()
      setIsAnyDropdownOpen(false)
    }

    setIsMobileMenuOpen(value)
  }

  const handleNavItemBackgroundClick = useCallback((event) => {
    if (
      event.target.closest(
        'a, button, .menu-dropdown, [data-prevent-nav-click]'
      )
    ) {
      return
    }

    const trigger = event.currentTarget.querySelector('.nav-hover-trigger')
    if (!trigger) {
      return
    }

    const link = trigger.querySelector('a[href]')
    if (!link) {
      return
    }

    link.click()
  }, [])

  const isLogoCollapsed = isMobileMenuOpen === true || !isScrolledTop
  const indicatorClasses = `nav-hover-indicator${
    navIndicator.visible ? ' is-visible' : ''
  }${navIndicator.noTransition ? ' no-transition' : ''}`
  const navIndicatorStyle = {
    width: navIndicator.width,
    height: navIndicator.height,
    transform: `translate3d(${navIndicator.left}px, ${navIndicator.top}px, 0) skewX(${INDICATOR_SKEW_DEG}deg)`,
    backgroundColor: navIndicator.color,
  }
  return (
    <>
      <div id={'sideMenuWrapper'} className="test">
        {isAboutUsMenuVisible && <SideMenu lang={lang} isGhost={true} />}
        {isServicesMenuVisible && (
          <SideMenuServices lang={lang} isGhost={true} />
        )}
        {isOurWorkMenuVisible && <CaseStudiesSideMenuGhost lang={lang} />}
      </div>
      <div
        className={`nav-page-backdrop${isAnyDropdownOpen ? ' is-visible' : ''}`}
      />
      <header className={`${isScrolledTop && !isCaseStudy ? '' : 'stick'}`}>
        <div className="container-fluid ml-0">
          <div className="row align-items-center">
            <div className="col-lg-2 fix-bg-mobile">
              <div
                id="desktop-logo"
                className={isMobileMenuOpen ? 'menu-open' : 'menu-close'}
                onClick={() => {
                  if (['', '/', '/en', '/en/'].indexOf(currentPath) !== -1) {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }
                }}
              >
                <TranslatedLink
                  to="/en"
                  title-bak={'Narative'}
                  onClick={() => onNavMenuOpen(false)}
                >
                  <Logo isCollapsed={isLogoCollapsed} />
                </TranslatedLink>
              </div>
            </div>
            <div
              className={
                'col-lg-8 d-flex align-items-center justify-content-center ' +
                (isMobileMenuOpen ? ' open' : '')
              }
            >
              <span
                className="mobile-Menu-open-menu"
                id="rwd-open-menu"
                onClick={() => onNavMenuOpen(true)}
              >
                <i className="la la-bars"></i>
              </span>
              <span
                className="mobile-Menu-close-menu"
                id="rwd-close-menu"
                onClick={() => onNavMenuOpen(false)}
              >
                <i className="la la-close"></i>
              </span>
              <nav
                ref={navRef}
                className={'main-menu ' + (isMobileMenuOpen ? 'open' : '')}
                onMouseLeave={restoreDefaultIndicator}
                onBlur={(event) => {
                  if (!event.currentTarget.contains(event.relatedTarget)) {
                    restoreDefaultIndicator()
                  }
                }}
              >
                <ul>
                  {/* Mobile-only feature boxes — shown only when mobile menu is open */}
                  {isMobileMenuOpen && (
                    <li className="nav-mobile-boxes-li d-lg-none">
                      <div className="nav-mobile-boxes">
                        {navBoxes.map((box, i) => (
                          <TranslatedLink
                            key={i}
                            to={box.link}
                            className="nav-mobile-box"
                            onClick={() => onNavMenuOpen(false)}
                          >
                            <div className="nav-mobile-box-img">
                              <img src={box.img} alt={box.title} />
                            </div>
                            <div className="nav-mobile-box-text">
                              <div className="nav-mobile-box-title">
                                {box.title}
                              </div>
                              <UnderlineLink>Zistiť viac</UnderlineLink>
                            </div>
                          </TranslatedLink>
                        ))}
                      </div>
                    </li>
                  )}

                  {/* Služby — first in DOM for mobile order */}
                  <li
                    data-nav-item="true"
                    className="order-lg-2"
                    onMouseEnter={(event) => {
                      handleNavItemEnter(event.currentTarget)
                      if (!isMobileMenuOpen) servicesDropdownRef.current?.open()
                    }}
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    {!isMobileMenuOpen ? (
                      <span className="nav-hover-trigger">
                        <DesktopDropdown
                          ref={servicesDropdownRef}
                          links={links}
                          navBoxes={navBoxes}
                          lang={lang}
                          onClick={() => onNavMenuOpen(false)}
                          btnName={t('Navigation.services')}
                          btnLink="/en/services"
                          onOpenChange={handleDropdownOpenChange}
                        />
                      </span>
                    ) : (
                      <>
                        <MobileDropdown
                          lang={lang}
                          onNavMenuOpen={onNavMenuOpen}
                          links={links}
                          btnName={t('Navigation.services')}
                          btnLink="/en/services"
                          defaultOpen={true}
                        />
                      </>
                    )}
                  </li>

                  {/* Naše práce — second in DOM (after Služby for mobile, first on desktop via order-lg-1) */}
                  <li
                    data-nav-item="true"
                    className="order-lg-1"
                    onMouseEnter={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    {!isMobileMenuOpen ? (
                      <LinkBtn
                        className="nav-hover-link nav-hover-trigger"
                        color="blue"
                        noUnderline={true}
                      >
                        <MultiTargetTranslatedLink
                          onClick={() => onNavMenuOpen(false)}
                          targets={[
                            '/en/our-works',
                            '/en/our-works/featured',
                            '/en/our-works/websites',
                            '/en/our-works/applications',
                            '/en/our-works/graphics',
                          ]}
                          to="/en/our-works/featured"
                          title-bak={t('Navigation.ourWork')}
                        >
                          {t('Navigation.ourWork')}
                        </MultiTargetTranslatedLink>
                      </LinkBtn>
                    ) : (
                      <MultiTargetTranslatedLink
                        onClick={() => onNavMenuOpen(false)}
                        targets={[
                          '/en/our-works',
                          '/en/our-works/featured',
                          '/en/our-works/websites',
                          '/en/our-works/applications',
                          '/en/our-works/graphics',
                        ]}
                        to="/en/our-works/featured"
                        title-bak={t('Navigation.ourWork')}
                      >
                        {t('Navigation.ourWork')}
                      </MultiTargetTranslatedLink>
                    )}
                  </li>

                  <li
                    data-nav-item="true"
                    className="order-lg-3"
                    onMouseEnter={(event) => {
                      handleNavItemEnter(event.currentTarget)
                      if (!isMobileMenuOpen) aboutUsDropdownRef.current?.open()
                    }}
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    {!isMobileMenuOpen ? (
                      <span className="nav-hover-trigger">
                        <DesktopDropdown
                          ref={aboutUsDropdownRef}
                          links={[aboutUsLinks]}
                          lang={lang}
                          onClick={() => onNavMenuOpen(false)}
                          btnName={t('Navigation.aboutUs')}
                          btnLink="/en/about-us"
                          onOpenChange={handleDropdownOpenChange}
                        />
                      </span>
                    ) : (
                      <>
                        <MobileDropdown
                          lang={lang}
                          onNavMenuOpen={onNavMenuOpen}
                          links={[aboutUsLinks]}
                          btnName={t('Navigation.aboutUs')}
                          btnLink="/en/about-us"
                        />
                      </>
                    )}
                  </li>
                  <li
                    data-nav-item="true"
                    className="order-lg-4"
                    onMouseEnter={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    {!isMobileMenuOpen ? (
                      <LinkBtn
                        className="nav-hover-link nav-hover-trigger"
                        color="blue"
                        noUnderline={true}
                      >
                        <MultiTargetTranslatedLink
                          onClick={() => onNavMenuOpen(false)}
                          targets={['/en/blog']}
                          to="/en/blog"
                          title-bak={t('Navigation.blog')}
                        >
                          {t('Navigation.blog')}
                        </MultiTargetTranslatedLink>
                      </LinkBtn>
                    ) : (
                      <MultiTargetTranslatedLink
                        onClick={() => onNavMenuOpen(false)}
                        targets={['/en/blog']}
                        to="/en/blog"
                        title-bak={t('Navigation.blog')}
                      >
                        {t('Navigation.blog')}
                      </MultiTargetTranslatedLink>
                    )}
                  </li>
                  <li
                    data-nav-item="true"
                    className="order-lg-5 d-none d-lg-inline-block"
                    onMouseEnter={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    <LinkBtn
                      className="nav-hover-link nav-hover-trigger"
                      color="blue"
                      noUnderline={true}
                    >
                      <MultiTargetTranslatedLink
                        onClick={() => onNavMenuOpen(false)}
                        strict={true}
                        targets={['/en/brief', '/dotaznik']}
                        to="/en/brief"
                        title-bak={t('Navigation.brief')}
                      >
                        {t('Navigation.brief')}
                      </MultiTargetTranslatedLink>
                    </LinkBtn>
                  </li>
                  <li
                    data-nav-item="true"
                    className="order-lg-6 d-none d-lg-inline-block"
                    onMouseEnter={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onFocusCapture={(event) =>
                      handleNavItemEnter(event.currentTarget)
                    }
                    onClickCapture={(event) =>
                      updateIndicatorForTarget(event.currentTarget, true)
                    }
                    onClick={handleNavItemBackgroundClick}
                  >
                    <LinkBtn
                      className="nav-hover-link nav-hover-trigger red"
                      noUnderline={true}
                    >
                      <MultiTargetTranslatedLink
                        onClick={() => onNavMenuOpen(false)}
                        strict={true}
                        targets={Array.from(
                          new Set([
                            '/en/contact',
                            getTranslatedSlug('/en/contact'),
                          ])
                        )}
                        to="/en/contact"
                        title-bak={t('Navigation.contact')}
                      >
                        {t('Navigation.contact')}
                      </MultiTargetTranslatedLink>
                    </LinkBtn>
                  </li>
                  {isMobileMenuOpen && (
                    <li className="d-lg-none mobile-accent-link-item">
                      <MultiTargetTranslatedLink
                        onClick={() => onNavMenuOpen(false)}
                        strict={true}
                        targets={Array.from(
                          new Set([
                            '/en/contact',
                            getTranslatedSlug('/en/contact'),
                          ])
                        )}
                        to="/en/contact"
                      >
                        {t('Navigation.contact')}
                      </MultiTargetTranslatedLink>
                    </li>
                  )}
                </ul>

                {isMobileMenuOpen && (
                  <div className="nav-mobile-cta">
                    <div className="nav-mobile-cta-inner">
                      <div className="nav-mobile-cta-content">
                        <img
                          src={ctaDocIcon}
                          alt=""
                          className="nav-mobile-cta-icon"
                        />
                        <div className="nav-mobile-cta-text">
                          <div className="nav-mobile-cta-title">
                            Pomôžeme vám so zadaním?
                          </div>
                          <div className="nav-mobile-cta-desc">
                            Vyplňte náš dotazník a my lepšie pochopíme vaše
                            ciele, rozsah projektu aj očakávania.
                          </div>
                        </div>
                      </div>
                      <LinkBtn
                        showBg={true}
                        size={1}
                        title="Zistite viac"
                        color="blue"
                      >
                        <TranslatedLink to="/dotaznik">
                          <span class="pl-4 pr-4">
                            Vyplňte dotazník
                            <img src={arowRight} alt="" className="fix-arrow" />
                          </span>
                        </TranslatedLink>
                      </LinkBtn>
                    </div>
                    <div className="nav-mobile-contact">
                      <div class="contact-link-cont">
                        <MailLink />
                      </div>
                      <div class="contact-link-cont">
                        <TelephoneNumber />
                      </div>
                    </div>
                  </div>
                )}

                <span
                  className={indicatorClasses}
                  style={navIndicatorStyle}
                  aria-hidden="true"
                />
              </nav>
            </div>
            <div className="col-lg-2 d-none d-lg-flex align-items-center justify-content-end">
              <div className="nav-lang-flag ml-4 mr-4 pt-2">
                <Tooltip
                  tagName={'span'}
                  content={'Not available in your area'}
                  direction="down"
                  arrow={false}
                  distance={20}
                >
                  <Img fixed={usFlag.childImageSharp.fixed} alt="language" />
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenuAboutUs lang={lang} sticky={isScrolledTop} />
      <MobileMenuBlog lang={lang} sticky={isScrolledTop} />
      <MobileMenuCaseStudies
        lang={lang}
        sticky={isScrolledTop}
        path={currentPath}
      />
      <MobileMenuCaseStudyPageShowcase
        lang={lang}
        sticky={isScrolledTop}
        path={currentPath}
      />
      <MobileMenuServices
        lang={lang}
        sticky={isScrolledTop}
        path={currentPath}
      />
    </>
  )
}

const DesktopDropdown = forwardRef(function DesktopDropdown(
  { links, btnName, btnLink, navBoxes, onOpenChange, lang },
  ref
) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const closeTimer = useRef(null)
  const dropdownIdRef = useRef(Symbol('desktop-dropdown'))
  const isDropdownOpenRef = useRef(false)
  const containerRef = useRef(null)

  const clearTimer = useCallback(() => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current)
      closeTimer.current = null
    }
  }, [])

  const updateDropdownOpenState = useCallback(
    (nextOpen) => {
      if (isDropdownOpenRef.current === nextOpen) {
        return
      }

      isDropdownOpenRef.current = nextOpen
      setDropdownOpen(nextOpen)
      onOpenChange?.(dropdownIdRef.current, nextOpen)
    },
    [onOpenChange]
  )

  const handleOpen = useCallback(() => {
    clearTimer()
    updateDropdownOpenState(true)
  }, [clearTimer, updateDropdownOpenState])

  useImperativeHandle(ref, () => ({ open: handleOpen }), [handleOpen])

  // Close only when cursor leaves both the nav-dropdown container AND the parent li
  useEffect(() => {
    if (!dropdownOpen) return

    const handleMouseOver = (e) => {
      const container = containerRef.current
      if (!container) return

      const parentLi = container.closest('li[data-nav-item]')
      const withinBounds =
        container.contains(e.target) ||
        (parentLi && parentLi.contains(e.target))

      if (withinBounds) {
        clearTimer()
      } else if (!closeTimer.current) {
        closeTimer.current = setTimeout(() => {
          closeTimer.current = null
          updateDropdownOpenState(false)
        }, 200)
      }
    }

    document.addEventListener('mouseover', handleMouseOver)
    return () => document.removeEventListener('mouseover', handleMouseOver)
  }, [dropdownOpen, clearTimer, updateDropdownOpenState])

  useEffect(
    () => () => {
      clearTimer()

      if (isDropdownOpenRef.current) {
        onOpenChange?.(dropdownIdRef.current, false)
        isDropdownOpenRef.current = false
      }
    },
    [onOpenChange, clearTimer]
  )

  const onNavLinkClick = (link) => {
    translatedNavigate(link, lang)
    updateDropdownOpenState(false)
  }

  const targets = () => {
    let t = []
    for (const [, value] of Object.entries(links)) {
      t = [...t, ...value.links.map((item) => item.link)]
    }
    return t
  }

  const isMega = navBoxes && navBoxes.length > 0
  const position = links.length > 2 ? 'left' : 'center'

  return (
    <div
      ref={containerRef}
      className={`nav-dropdown ${dropdownOpen ? 'dropdown-open' : ''}`}
      onMouseEnter={handleOpen}
      onClick={(e) => {
        if (!e.target.closest('a, button, li')) handleOpen()
      }}
    >
      <LinkBtn
        className="nav-hover-link"
        dropdown={true}
        color={'blue'}
        noUnderline={true}
      >
        <MultiTargetTranslatedLink
          strict={true}
          targets={targets()}
          to={btnLink}
          title-bak={btnName}
        >
          {btnName}
        </MultiTargetTranslatedLink>
      </LinkBtn>

      <div
        className={`menu-dropdown ${isMega ? 'mega' : ''} ${
          dropdownOpen ? 'show' : 'hide'
        } ${position}`}
        onMouseEnter={handleOpen}
      >
        <div className="menu-dropdown-cont">
          {isMega ? (
            <>
              <div className="menu-dropdown-inner">
                {/* Left: featured boxes */}
                <div className="nav-featured-boxes">
                  {navBoxes.map((box, i) => (
                    <TranslatedLink
                      key={i}
                      to={box.link}
                      className="nav-featured-box"
                      onClick={() => {
                        updateDropdownOpenState(false)
                      }}
                    >
                      <div className="nav-featured-box-text">
                        <div className="nav-featured-box-title">
                          {box.title}
                        </div>
                        <div className="nav-featured-box-desc">{box.desc}</div>
                        <UnderlineLink>Zistiť viac</UnderlineLink>
                      </div>
                      <div className="nav-featured-box-img">
                        <img src={box.img} alt={box.title} />
                      </div>
                    </TranslatedLink>
                  ))}
                </div>

                {/* Right: service columns */}
                <div className="dropdown-columns">
                  <div className="dropdown-content">
                    {links.map((part, i) => (
                      <div key={i}>
                        {part.title && (
                          <div
                            className="menu-header"
                            onClick={() => onNavLinkClick(part.link)}
                          >
                            <div>
                              <MultiTargetTranslatedLink
                                strict={true}
                                targets={[part.link]}
                                to={part.link}
                              >
                                {part.title}
                              </MultiTargetTranslatedLink>
                            </div>
                          </div>
                        )}
                        <ul className={!part.title ? 'no-parent' : ''}>
                          {part.links.map((link, key) => (
                            <li
                              key={key}
                              onClick={() => onNavLinkClick(link.link)}
                            >
                              <MultiTargetTranslatedLink
                                strict={true}
                                targets={[link.link]}
                                to={link.link}
                              >
                                {link.icon && (
                                  <Svg
                                    className="nav-item-icon"
                                    src={link.icon}
                                    width="40px"
                                    height="40px"
                                    uniquifyIDs={false}
                                  />
                                )}
                                <span className="nav-item-text">
                                  <span className="nav-item-name">
                                    {link.title}
                                  </span>
                                  {link.desc && (
                                    <span className="nav-item-desc">
                                      {link.desc}
                                    </span>
                                  )}
                                </span>
                              </MultiTargetTranslatedLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* CTA bar */}
              <div className="nav-cta-bar">
                <img src={ctaDocIcon} alt="" className="nav-cta-icon" />
                <div className="nav-cta-text">
                  <div className="nav-cta-title">Pomôžeme vám so zadaním?</div>
                  <div className="nav-cta-desc">
                    Vyplňte náš dotazník a my lepšie pochopíme vaše ciele,
                    rozsah projektu aj očakávania.
                  </div>
                </div>
                <LinkBtn
                  showBg={true}
                  size={1}
                  title="Zistite viac"
                  color="blue"
                >
                  <TranslatedLink to="/dotaznik">
                    <span class="pl-5 pr-5">
                      Vyplňte dotazník
                      <img src={arowRight} alt="" className="fix-arrow" />
                    </span>
                  </TranslatedLink>
                </LinkBtn>
              </div>
            </>
          ) : (
            /* Simple dropdown (e.g. O nás) */
            <div className="dropdown-content">
              {links.map((part, i) => (
                <div key={i}>
                  {part.title && (
                    <div
                      className="menu-header m-0"
                      onClick={() => onNavLinkClick(part.link)}
                    >
                      <div>
                        <Svg
                          className="ml-1"
                          width="18px"
                          height="18px"
                          src={part.svg}
                          uniquifyIDs={false}
                        />
                        <MultiTargetTranslatedLink
                          strict={true}
                          targets={[part.link]}
                          to={part.link}
                        >
                          {part.title}
                        </MultiTargetTranslatedLink>
                      </div>
                    </div>
                  )}
                  <ul className={`${!part.link ? 'no-parent' : ''}`}>
                    {part.links.map((link, key) => (
                      <li key={key} onClick={() => onNavLinkClick(link.link)}>
                        <MultiTargetTranslatedLink
                          strict={true}
                          targets={[link.link]}
                          to={link.link}
                        >
                          <span className="nav-item-name">{link.title}</span>
                        </MultiTargetTranslatedLink>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
})

const MobileDropdown = ({
  onNavMenuOpen,
  btnName,
  btnLink,
  links,
  defaultOpen,
  lang,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(() => {
    if (defaultOpen) return true

    const isActive =
      links.filter((item) => {
        return (
          item.links.filter((childItem) =>
            matchPath(globalHistory.location.pathname, childItem.link, true)
          ).length > 0
        )
      }).length > 0

    if (isActive) return true

    return false
  })

  const onNavLinkClick = () => {
    onNavMenuOpen(false)
  }

  const isActive = (url) => {
    return globalHistory.location.pathname.startsWith(url)
  }

  return (
    <div className={`mobile-dropdown ${dropdownOpen ? 'open' : ''}`}>
      <div className={`dropdown-title ${dropdownOpen ? 'open' : ''}`}>
        <div
          className={`dropdown-title-text`}
          onClick={(e) => onNavLinkClick()}
        >
          {
            <MultiTargetTranslatedLink
              strict={true}
              targets={[btnLink]}
              to={btnLink}
              title-bak={btnName}
            >
              {btnName}
            </MultiTargetTranslatedLink>
          }
        </div>

        <div
          className="dropdown-subtitle-arrow"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <svg width="12" viewBox="0 0 14 9" fill="none" className="ml-lg-2">
            <path
              d="M7.00023 8.21309L13.0102 2.20309L11.5972 0.788086L7.00023 5.38809L2.40423 0.788086L0.990234 2.20209L7.00023 8.21309Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      {dropdownOpen && (
        <>
          {links.map((group, key) => (
            <MobileDropdownItems
              key={key}
              onNavMenuOpen={onNavMenuOpen}
              lang={lang}
              title={group.title}
              group={group}
              url={group.link}
              links={group.links}
            />
          ))}
        </>
      )}
    </div>
  )
}

const MobileDropdownItems = ({
  title,
  group,
  url,
  links,
  onNavMenuOpen,
  lang,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(() => {
    const isActive =
      links.filter((item) =>
        matchPath(globalHistory.location.pathname, item.link, true)
      ).length > 0

    if (!title || !url || isActive) {
      return true
    }
    return false
  })

  const onNavLinkClick = () => {
    translatedNavigate(url, lang)
    onNavMenuOpen(false)
  }

  const isActive = (link) => {
    return matchPath(globalHistory.location.pathname, link, true)
  }
  return (
    <div
      className={`dropdown-items-cont ${dropdownOpen ? 'open' : ''} ${
        group.class ? group.class : ''
      }`}
    >
      {title && (
        <div className={`dropdown-subtitle`}>
          <div
            className={`dropdown-subtitle-link ${
              isActive(url) ? 'active' : ''
            }`}
            onClick={() => onNavLinkClick()}
          >
            {title}
          </div>
          <div
            className="dropdown-subtitle-arrow"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <svg width="12" viewBox="0 0 14 9" fill="none" className="ml-lg-2">
              <path
                d="M7.00023 8.21309L13.0102 2.20309L11.5972 0.788086L7.00023 5.38809L2.40423 0.788086L0.990234 2.20209L7.00023 8.21309Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      )}
      {dropdownOpen && (
        <ul className={`dropdown-items`}>
          {links.map((link, key) => (
            <li
              key={key}
              className={link.icon ? 'has-icon' : ''}
              onClick={() => onNavMenuOpen(false)}
            >
              {link.icon && (
                <Svg src={link.icon} className="mobile-nav-item-icon" />
              )}
              <MultiTargetTranslatedLink
                strict={true}
                targets={[link.link]}
                to={link.link}
                title-bak={link.title}
              >
                {link.title}
              </MultiTargetTranslatedLink>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Navigation
